import { usePublicOffer } from './use-public-offer';

export const publicOfferModel = {
  usePublicOffer,
};
